/** Fields GET /org/products sorts on; anything else is a 400. */
export const PRODUCT_SORTS = ['title', 'createdAt', 'updatedAt', 'price'] as const;

/**
 * Params the list used to take that moved (D-182): `tag` is the one-tag alias of the tags
 * filter and `storeId` of "In store". Old links and bookmarks keep working: the search schema
 * reads them into the new params when those are absent, and the next filter change writes the
 * new names to the URL.
 */
export const LEGACY_PRODUCT_PARAMS = { tag: 'tags', storeId: 'inStoreId' } as const;
